module.exports = __webpack_public_path__ + "static/big-tent-35cf7f5f272ad20608dd750c87397c30.jpg";